import { useState } from 'preact/hooks';

/**
 * Nation identity disc — the app's "bottle cap" motif. Renders a team's flag
 * (a `.webp` under /flags/) clipped to a circle with the crimp-ring shading
 * from the design handoff. Falls back to a neutral amber monogram when the
 * flag is missing or the slot is unresolved (knockout "Winner Group A").
 *
 * `flag` is the bundle's per-team filename (e.g. "ch.webp"). `code` is the
 * 3-letter team code used for the alt text + monogram fallback.
 */
export function BottleCap({
  flag,
  code,
  size = 44,
  title,
}: {
  flag?: string;
  code?: string;
  size?: number;
  title?: string;
}) {
  const [broken, setBroken] = useState(false);
  const showFlag = flag && !broken;
  return (
    <div
      class="bc-cap"
      title={title ?? code}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }}
    >
      {showFlag ? (
        <img src={`/flags/${flag}`} alt={code ?? ''} onError={() => setBroken(true)} />
      ) : (
        <span class="bc-cap__mono">{(code ?? '?').slice(0, 3)}</span>
      )}
      <span class="bc-cap__ring" aria-hidden="true" />
    </div>
  );
}
